import { useHead } from "#app";
import { parse } from "node-html-parser";
import { defineNuxtPlugin } from "nuxt/app";

import {
  getFontAwesomeIconData,
  iconDataToCss,
  initFontAwesome,
} from "@solvari/common-fe/integrations";

// Reparse cost: 4.7 ms/100 kB, 8.8 ms/250 kB, 17.8 ms/500 kB (node-html-parser).
// Small against CMS/API latency; route cache absorbs it on a hit.
export default defineNuxtPlugin((nuxtApp) => {
  if (import.meta.server) {
    nuxtApp.hook("app:rendered", (context) => {
      const html = context.renderResult?.html;
      if (html) {
        const document = parse(html);
        const iconData = getFontAwesomeIconData(
          document as unknown as HTMLElement,
        );
        useHead({
          link: iconData.map(({ iconUrl }) => {
            return {
              rel: "preload",
              href: iconUrl,
              crossorigin: "",
              as: "image",
              type: "image/svg+xml",
              fetchpriority: "low",
            } as const;
          }),
        });
        const css = iconDataToCss(iconData);
        useHead({ style: [{ innerHTML: css, id: "s-font-awesome" }] });
      }
    });
  }

  if (import.meta.client) {
    initFontAwesome();
  }
});
